// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__IISoz","buttons":"SendReceipts_buttons__1amnq","email":"SendReceipts_email__169hn","bookApptTitle":"SendReceipts_bookApptTitle__2gXhi"};